import {ActionReducerMapBuilder, createSlice} from '@reduxjs/toolkit'
import {AnalyticsDetailState} from 'interfaces'
import {
  resetAnalyticsDetailState,
  setAnalyticsDetailFilters,
  setSortAscending,
} from './analyticsDetailAction'
import {policyTypeFilterValues} from './constant'

const initialState: AnalyticsDetailState = {
  policyType: policyTypeFilterValues,
  resourceType: [],
  filterDetails: {},
  sortAscending: false,
}

const analyticDetailSlice = createSlice({
  name: 'analyticDetail',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<AnalyticsDetailState>) =>
    builder
      .addCase(setAnalyticsDetailFilters, (state, action) => ({
        ...state,
        policyType: action?.payload?.policyType || initialState.policyType,
        resourceType:
          action?.payload?.resourceType || initialState.resourceType,
        filterDetails:
          action?.payload?.filterDetails || initialState.filterDetails,
      }))
      .addCase(setSortAscending, (state, action) => ({
        ...state,
        sortAscending: action.payload,
      }))
      .addCase(resetAnalyticsDetailState, () => ({
        ...initialState,
      }))
      .addDefaultCase(state => state),
})

export const {reducer: analyticDetailReducer, name: analyticDetailReducerName} =
  analyticDetailSlice

export type analyticDetailReducerState = ReturnType<
  typeof analyticDetailReducer
>

// export analytics detail action types
export type TAnalyticsDetailActions =
  | ReturnType<typeof setAnalyticsDetailFilters>
  | ReturnType<typeof resetAnalyticsDetailState>
  | ReturnType<typeof setSortAscending>

export const analyticsDetailActions = {
  setPolicyTypeFilter: setAnalyticsDetailFilters,
  resetAnalyticsDetailState,
  setSortAscending,
}
